import { useContext } from "react";
import { StatisticCassettesContext } from "./StatisticCassettes";

export default function useStatisticCassettesContext() {
    return useContext(StatisticCassettesContext);
};
